import {
	createActionsHook,
	createContainer,
	createHook,
	createStore,
	createSubscriber,
} from '@atlassian/eoc-rss-helpers';

import { actions } from './actions';
import { initialState } from './state';
import { type ContainerProps } from './types';

const store = createStore<typeof initialState, typeof actions>({
	initialState,
	actions,
});

const Container = createContainer<typeof initialState, typeof actions, ContainerProps>(store);

const Subscriber = createSubscriber<typeof initialState, typeof actions>(store);

const useStore = createHook<typeof initialState, typeof actions>(store);

const useActions = createActionsHook<typeof initialState, typeof actions>(store);

export { Container, Subscriber, useStore, useActions, store };
